<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>{{$route.query.id != null ? 'Editar' : 'Crear'}} albarán {{ $route.meta.especial ? "especial" : "" }}</h2></v-toolbar-title></pre>
                    </v-toolbar>

                    <v-form ref="linea_form" class="mt-3">
                        <v-row>
                            <v-tooltip right style="margin-bottom: 5px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        fab
                                        :to="$route.meta.lista"
                                        :loading="isloading"
                                        :disabled="isloading"
                                        color="blue"
                                        class="mt-4 mx-3"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon class="white--text"
                                            >mdi-arrow-left-bold-outline</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Volver</span>
                            </v-tooltip>
                        </v-row>
                        <v-tabs style="margin-top: 2rem">
                            <v-tab>Datos</v-tab>
                            <v-tab>Archivos</v-tab>

                            <v-tab-item>
                                <v-card
                                    style="
                                        min-width: 100%;
                                        padding: 1rem;
                                        margin-top: 2rem;
                                    "
                                >
                                    <h3>Datos albarán</h3>
                                    <v-row>
                                        <v-col cols="12" md="3">
                                            <v-text-field
                                                @change="checkNro"
                                                v-model="albaran.nro"
                                                label="Número"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <date-select
                                                v-model="albaran.fecha"
                                                label="Fecha"
                                            ></date-select>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-select
                                                v-model="albaran.tipo"
                                                :items="['Factura', 'Nota']"
                                                label="Tipo"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                    <h3>Datos proveedor</h3>
                                    <v-row>
                                        <v-col cols="12" md="5">
                                            <proveedoresSelectVue
                                                label="Proveedor"
                                                v-model="albaran.id_proveedor"
                                                item-text="nombre"
                                                item-value="id"
                                                :extra="albaran.proveedor"
                                                @change="proveedorSelected"
                                            ></proveedoresSelectVue>
                                        </v-col>

                                        <v-col cols="6" md="3">
                                            <v-autocomplete
                                                readonly
                                                v-model="albaran.id_proveedor"
                                                :items="proveedores"
                                                item-text="telefono"
                                                item-value="id"
                                                label="Teléfono"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="6" md="3">
                                            <v-autocomplete
                                                readonly
                                                v-model="albaran.id_proveedor"
                                                :items="proveedores"
                                                item-text="email"
                                                item-value="id"
                                                label="Email"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-card style="min-width: 100%; padding: 1rem">
                                    <h3>Nueva línea de albarán</h3>
                                    <v-row
                                        v-if="
                                            albaran.id_producto_compra == null
                                        "
                                    >
                                        <v-col cols="12" md="2">
                                            <v-autocomplete
                                                label="Pedido"
                                                v-model="linea.id_pedido"
                                                :items="Pedidos"
                                                item-text="id"
                                                item-value="id"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-autocomplete
                                                label="Pedido línea"
                                                v-model="linea.id_pedido_linea"
                                                :items="lineas"
                                                item-text="descripcion"
                                                item-value="id"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <ProductosCompraSelect
                                                v-model="
                                                    linea.id_producto_compra
                                                "
                                                item-text="titulo"
                                                item-value="id"
                                                label="Producto asociado"
                                                :extra="linea.producto"
                                            >
                                            </ProductosCompraSelect>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="3"
                                            v-if="!$route.meta.especial"
                                        >
                                            <v-autocomplete
                                                v-model="linea.id_iva"
                                                label="IVA"
                                                :items="ivas"
                                                item-value="id"
                                                item-text="descripcion"
                                                :rules="required_val"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="5">
                                            <v-text-field
                                                v-model="linea.descripcion"
                                                label="Descripción"
                                                :rules="required_val"
                                            >
                                            </v-text-field>
                                        </v-col>

                                        <v-col cols="12" md="1">
                                            <div class="spacing">
                                                <v-text-field-comma
                                                    v-model="linea.cantidad"
                                                    type="number"
                                                    label="Cantidad"
                                                    :rules="required_val_0"
                                                >
                                                </v-text-field-comma>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="1">
                                            <div class="spacing">
                                                <v-text-field-comma
                                                    v-model="linea.precio"
                                                    type="number"
                                                    label="Precio unitario"
                                                    :rules="required_val_0"
                                                >
                                                </v-text-field-comma>
                                            </div>
                                        </v-col>

                                        <v-col cols="12" md="2">
                                            <div style="display: flex">
                                                <v-text-field-comma
                                                    v-model="linea.dcto"
                                                    type="number"
                                                    label="Descuento"
                                                >
                                                </v-text-field-comma>
                                                <v-btn-toggle
                                                    color="primary"
                                                    shaped
                                                    v-model="linea.tipo_dcto"
                                                    background-color="white"
                                                >
                                                    <v-btn text>
                                                        <v-icon
                                                            >mdi-percent</v-icon
                                                        >
                                                    </v-btn>
                                                    <v-btn text>
                                                        <v-icon
                                                            >mdi-currency-eur</v-icon
                                                        >
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="1">
                                            <v-btn
                                                @click="addLinea()"
                                                :disabled="isloading"
                                                color="success"
                                                class="white--text"
                                                >Añadir</v-btn
                                            >
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-card style="min-width: 100%; padding: 1rem">
                                    <h3 style="margin-top: 10px">
                                        Líneas albarán
                                    </h3>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                            v-for="(
                                                item, key, index
                                            ) in lineas_formated"
                                            :key="index"
                                        >
                                            <h4>
                                                {{ item.pedido }}
                                            </h4>
                                            <v-data-table
                                                dense
                                                :headers="
                                                    $route.meta.especial == 1
                                                        ? headers_especial
                                                        : headers
                                                "
                                                hide-default-footer
                                                disable-pagination
                                                :items="item.lineas"
                                                item-key="id"
                                                class="elevation-1"
                                            >
                                                <template
                                                    v-slot:item.cantidad="{
                                                        item,
                                                    }"
                                                >
                                                    {{
                                                        item.cantidad
                                                            | decimalComma
                                                    }}
                                                </template>
                                                <template
                                                    v-slot:item.precio="{
                                                        item,
                                                    }"
                                                >
                                                    {{
                                                        formatPrice(item.precio)
                                                    }}
                                                </template>
                                                <template
                                                    v-slot:item.iva="{ item }"
                                                >
                                                    {{ formatPrice(item.iva) }}
                                                </template>
                                                <template
                                                    v-slot:item.subtotal="{
                                                        item,
                                                    }"
                                                >
                                                    {{
                                                        formatPrice(
                                                            item.precio *
                                                                item.cantidad
                                                        )
                                                    }}
                                                </template>
                                                <template
                                                    v-slot:item.dcto="{ item }"
                                                >
                                                    {{ formatPrice(item.dcto) }}
                                                </template>
                                                <template
                                                    v-slot:item.total="{ item }"
                                                >
                                                    {{
                                                        formatPrice(item.total)
                                                    }}
                                                </template>
                                                <template
                                                    v-slot:item.dcto_total="{
                                                        item,
                                                    }"
                                                >
                                                    {{
                                                        formatPrice(
                                                            CalcularTotalDcto(
                                                                item
                                                            )
                                                        )
                                                    }}
                                                </template>
                                                <template
                                                    v-slot:item.action="{
                                                        item,
                                                    }"
                                                >
                                                    <v-icon
                                                        @click="
                                                            openEditDialog(item)
                                                        "
                                                        small
                                                        class="mr-2"
                                                        color="black"
                                                        style="font-size: 25px"
                                                        title="EDITAR"
                                                        >mdi-pencil-outline</v-icon
                                                    >

                                                    <v-icon
                                                        @click="
                                                            openDeleteDialog(
                                                                item
                                                            )
                                                        "
                                                        small
                                                        class="mr-2"
                                                        color="red"
                                                        style="font-size: 25px"
                                                        title="BORRAR"
                                                        >mdi-trash-can</v-icon
                                                    >
                                                </template>
                                            </v-data-table>
                                        </v-col>
                                    </v-row>
                                    <v-row align="start" justify="end">
                                        <v-col cols="8"> </v-col>
                                        <v-col cols="12" md="4">
                                            <v-card
                                                style="
                                                    min-width: 100%;
                                                    padding: 1rem;
                                                "
                                            >
                                                <v-row>
                                                    <v-col cols="6">
                                                        <h4
                                                            style="
                                                                text-wrap: nowrap;
                                                            "
                                                        >
                                                            Base imponible:
                                                        </h4>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <h4
                                                            style="
                                                                text-wrap: nowrap;
                                                                text-align: right;
                                                            "
                                                        >
                                                            {{
                                                                formatPrice(
                                                                    total
                                                                )
                                                            }}
                                                        </h4>
                                                    </v-col>
                                                </v-row>
                                                <v-row
                                                    v-for="(
                                                        total, tipoIva
                                                    ) in iva"
                                                    :key="tipoIva"
                                                >
                                                    <v-col cols="6">
                                                        <h4>
                                                            IVA {{ tipoIva }}%:
                                                        </h4>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <h4
                                                            style="
                                                                text-align: right;
                                                            "
                                                        >
                                                            {{
                                                                formatPrice(
                                                                    total
                                                                )
                                                            }}
                                                        </h4>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="6">
                                                        <h4>Total:</h4>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <h4
                                                            style="
                                                                text-wrap: nowrap;
                                                                text-align: right;
                                                            "
                                                        >
                                                            {{
                                                                formatPrice(
                                                                    albaran.importe +
                                                                        albaran.iva
                                                                )
                                                            }}
                                                        </h4>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-textarea
                                                v-model="albaran.observaciones"
                                                label="Observaciones"
                                                outlined
                                            >
                                            </v-textarea>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <MetodosDePagoSelect
                                                v-model="albaran.metodo_pago_id"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-card>

                                <!-- Botones de acciones del formulario -->
                                <v-row style="margin-top: 10px">
                                    <v-col cols="12">
                                        <router-link to="lista-albaranes">
                                            <v-btn
                                                color="red"
                                                class="white--text mr-2"
                                            >
                                                Cancelar
                                            </v-btn>
                                        </router-link>
                                        <v-btn
                                            v-if="!albaran.id"
                                            @click="saveAlbaran(null)"
                                            :disabled="isloading"
                                            color="success"
                                            class="white--text mr-2"
                                            >Guardar</v-btn
                                        >
                                        <v-btn
                                            v-if="albaran.id"
                                            @click="especial_dialog = true"
                                            :disabled="isloading"
                                            color="success"
                                            class="white--text mr-2"
                                            >Pasar a
                                            {{
                                                this.$route.meta.especial == 0
                                                    ? "especial"
                                                    : "normal"
                                            }}
                                        </v-btn>
                                        <v-btn
                                            v-if="albaran.id"
                                            @click="saveAlbaran(null)"
                                            :disabled="isloading"
                                            color="success"
                                            class="white--text mr-2"
                                            >Actualizar</v-btn
                                        >

                                        <v-btn
                                            v-if="albaran.metodo_pago_id == 3"
                                            @click="generarNota"
                                            :disabled="isloading"
                                            color="success"
                                            class="white--text mr-2"
                                        >
                                            Generar nota
                                        </v-btn>
                                        <v-btn
                                            v-else
                                            :disabled="isloading"
                                            @click="crearFactura"
                                            color="success"
                                            class="white--text"
                                        >
                                            Generar factura
                                        </v-btn>
                                        <!--v-btn
                                            v-if="albaran.id"
                                            @click="openFacturaDialog"
                                            :disabled="isloading"
                                            color="primary"
                                            class="white--text"
                                            >Crear Factura</!--v-btn
                                        -->
                                        <!-- <router-link
                                    :to="{
                                        path: `/lista-abonos?id=${factura.id}`,
                                    }"
                                >
                                    <v-btn
                                        v-if="factura.id"
                                        :disabled="isloading"
                                        color="blue"
                                        class="white--text"
                                        >Abonos</v-btn
                                    >
                                </router-link> -->
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item>
                                <listaArchivos
                                    v-on:delete_archivo="deleteArchivo"
                                    :items="albaran.archivo"
                                    @subir_file_64="subirArchivo"
                                >
                                </listaArchivos>
                            </v-tab-item>
                        </v-tabs>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>

        <!-- Agregar linea -->
        <v-dialog v-model="product_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Descripción del producto
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                v-model="linea.descripcion"
                                type="text"
                                label="Descripción del producto"
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn
                        color="success"
                        large
                        @click="
                            addLinea();
                            product_dialog = false;
                        "
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Cambiar el tipo de albaran -->
        <v-dialog v-model="especial_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    ¿Deseas cambiar el tipo de albarán?
                </v-card-title>
                <v-card-text style="text-align: center">
                    Se cambiara el estado de
                    {{
                        $route.meta.especial == 1
                            ? `especial a normal`
                            : `normal a especial`
                    }}
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn
                        color="success"
                        large
                        @click="
                            saveAlbaran($route.meta.especial == 1 ? 0 : 1);
                            especial_dialog = false;
                        "
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Editar linea -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Editar línea
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                label="Pedido"
                                v-model="editlinea.id_pedido"
                                :items="Pedidos"
                                item-text="id"
                                item-value="id"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="12">
                            <v-autocomplete
                                label="Pedido línea"
                                v-model="editlinea.id_pedido_linea"
                                :items="lineas"
                                item-text="descripcion"
                                item-value="id"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ProductosCompraSelect
                                v-model="editlinea.id_producto_compra"
                                item-text="nombre"
                                item-value="id"
                                label="Producto asociado"
                                :extra="editlinea.producto"
                            >
                            </ProductosCompraSelect>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="editlinea.cantidad"
                                    type="number"
                                    label="Cantidad"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete
                                v-model="editlinea.id_iva"
                                label="IVA"
                                :items="ivas"
                                item-value="id"
                                item-text="descripcion"
                                :rules="required_val"
                                v-if="!$route.meta.especial"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="editlinea.precio"
                                    type="number"
                                    label="Precio unitario"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>

                        <v-col cols="12" md="6">
                            <div style="display: flex">
                                <v-text-field-comma
                                    v-model="editlinea.dcto"
                                    type="number"
                                    label="Descuento"
                                >
                                </v-text-field-comma>
                                <v-btn-toggle
                                    color="primary"
                                    shaped
                                    v-model="editlinea.tipo_dcto"
                                    background-color="white"
                                >
                                    <v-btn text>
                                        <v-icon>mdi-percent</v-icon>
                                    </v-btn>
                                    <v-btn text>
                                        <v-icon>mdi-currency-eur</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                            </div>
                        </v-col>

                        <v-col cols="12">
                            <div class="spacing">
                                <v-text-field
                                    v-model="editlinea.descripcion"
                                    label="Descripción"
                                >
                                </v-text-field>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="success" large @click="Edit()"
                        >Modificar</v-btn
                    >

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--delete dialog-->
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="error" large @click="delete_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteLinea()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <ConfimDialog
            v-model="confirm_factura"
            title="Confirmar factura"
            message="Confirmar creación de factura"
            @confirm="crearFactura"
        ></ConfimDialog>
        <ConfimDialog
            v-model="redirect_factura"
            title="Ir a factura"
            message="¿Desea ir a la factura creada?"
            @confirm="
                $router.push(`/guardar-factura-entrante?id=${factura_id}`)
            "
        ></ConfimDialog>
    </v-container>
</template>

<script>
import { debounce } from "../../../helpers";
import moment from "moment";
import proveedoresSelectVue from "../../../components/general/proveedoresSelect.vue";
import ConfimDialog from "./ConfimDialog.vue";
import ProductosCompraSelect from "../../../components/general/ProductosCompraSelect.vue";
import listaArchivos from "../../../components/general/listaArchivos.vue";
import MetodosDePagoSelect from "../../../components/general/MetodosDePagoSelect.vue";
import { formatPrice } from "../../../helpers";

export default {
    components: {
        proveedoresSelectVue,
        ConfimDialog,
        ProductosCompraSelect,
        listaArchivos,
        MetodosDePagoSelect,
    },
    data() {
        return {
            especial_dialog: false,
            ivas: [],
            factura_id: null,
            redirect_factura: false,
            confirm_factura: false,
            selectedItem: null,
            productos_compra: [],
            lineas: [],
            required_val: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
            ],
            required_val_0: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
                (v) => v != 0 || "El campo no puede ser 0",
            ],
            product_dialog: false,

            dialog: false,
            delete_dialog: false,
            editlinea: {
                id: null,
                id_iva: 1,
                id_producto_compra: null,
                nombre_producto: "",
                descripcion: null,
                cantidad: null,
                precio: null,
                tipo_dcto: 1,
                dcto: 0,
                subtotal: 0,
                total: 0,
                observaciones: "",
                id_pedido: null,
                id_pedido_linea: null,
            },
            linea: {
                id_pedido: null,
                id_iva: 1,

                id_pedido_linea: null,
                id: null,
                id_producto_compra: null,
                nombre_producto: "",
                descripcion: null,
                cantidad: null,
                precio: null,
                tipo_dcto: 1,
                dcto: 0,
                subtotal: 0,
                total: 0,
                observaciones: "",
            },
            headers: [
                {
                    text: "Descripción",
                    value: "descripcion",
                    sortable: false,
                },
                {
                    text: "Cantidad",
                    value: "cantidad",
                    sortable: false,
                },
                {
                    text: "Precio unidad",
                    value: "precio",
                    sortable: false,
                },
                {
                    text: "Subtotal",
                    value: "subtotal",
                    sortable: false,
                },
                {
                    text: "Descuento",
                    value: "dcto",
                    sortable: false,
                },
                {
                    text: "Total",
                    value: "total",
                    sortable: false,
                },
                {
                    text: "IVA",
                    value: "iva",
                    sortable: false,
                },
                {
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                },
            ],
            headers_especial: [
                {
                    text: "Descripción",
                    value: "descripcion",
                    sortable: false,
                },
                {
                    text: "Cantidad",
                    value: "cantidad",
                    sortable: false,
                },
                {
                    text: "Precio unidad",
                    value: "precio",
                    sortable: false,
                },
                {
                    text: "Subtotal",
                    value: "subtotal",
                    sortable: false,
                },
                {
                    text: "Descuento",
                    value: "dcto",
                    sortable: false,
                },
                {
                    text: "Total",
                    value: "total",
                    sortable: false,
                },
                {
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                },
            ],
            albaran: {
                lineas: [],
                id_proveedor: null,
                metodo_pago_id: "",
                importe: 0,
                iva: 0,
            },
            //proveedores: [],
            Pedidos: [],

            metodos_pagos: [],

            producto: {},
        };
    },
    watch: {
        linea: function (val) {
            this.linea.tipo_dcto = 1;
        },

        "linea.id_pedido": function (val) {
            const lineas =
                this.Pedidos.find((ele) => ele.id == val)?.lineas ?? [];
            this.lineas = lineas;
            // console.log("lineas", this.lineas);
        },
        "linea.id_pedido_linea": function (val) {
            const linea = this.lineas.find((ele) => ele.id == val);
            // console.log(linea);
            const descripcion = linea?.descripcion ?? "";
            this.linea.descripcion = descripcion;
            this.linea.id_producto_compra = linea?.id_producto_compra;
            this.linea.precio = linea?.precio;
            this.linea.id_iva = linea?.producto?.id_iva;
            this.linea.cantidad = linea?.cantidad;
            this.linea.producto = linea?.producto;
            this.linea.dcto = linea?.dcto;
        },
        "editlinea.id_pedido": function (val) {
            const lineas =
                this.Pedidos.find((ele) => ele.id == val)?.lineas ?? [];
            this.lineas = lineas;
        },
        "editlinea.id_pedido_linea": function (val) {
            const linea = this.lineas.find((ele) => ele.id == val);
            const descripcion = linea?.descripcion ?? "";
            this.editlinea.descripcion = descripcion;
            this.editlinea.id_producto_compra = linea?.id_producto_compra;
            this.editlinea.precio = linea?.precio;
            this.editlinea.id_iva = linea?.producto?.id_iva;
            this.editlinea.cantidad = linea?.cantidad;
            this.editlinea.producto = linea?.producto;
            this.editlinea.dcto = linea?.dcto;
        },
    },
    created() {
        //this.getProductosCompra();
        //this.getProveedores();
        this.getIvas();

        if (this.$route.query.id) {
            this.getAlbaran(this.$route.query.id);
        }
    },
    methods: {
        // Acciones de albaran
        getAlbaran(id) {
            let me = this;
            axios.get(`api/get-albaran/${id}`).then(
                (res) => {
                    me.albaran = res.data.success;
                    me.albaran.lineas = me.albaran.lineas;
                    this.proveedorSelected(me.albaran.id_proveedor);
                    me.albaran.lineas.forEach((element) => {
                        me.getLinea(element);
                    });
                },
                (res) => {}
            );
        },
        checkNro() {
            axios.get(`api/get-albaran-nro/${this.albaran.nro}`).then((res) => {
                if (res.data == null || res.data == "") return;
                if (res.data.id != this.albaran.id) {
                    this.albaran.nro = "";
                    this.$toast.error("El número seleccionado ya existe");
                }
            });
        },
        saveAlbaran(especial) {
            if (especial == null) {
                this.albaran.especial = this.$route.meta.especial;
            } else {
                this.albaran.especial = especial;
            }
            axios
                .post("api/save-albaran", this.albaran)
                .then((res) => {
                    this.getAlbaran(res.data.data.id);
                    if (especial != null) {
                        this.$router.push(
                            `${this.$route.meta.guardar_contrario}?id=${this.$route.query.id}`
                        );
                        this.$router.go();
                    }
                })
                .catch((error) => {
                    if (error.response.code == 400) {
                        this.$custom_error(error.response.data.error);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },

        // Acciones de lineas de albaran
        getLinea(linea_l) {
            let linea = linea_l;

            linea.subtotal = linea.precio * linea.cantidad;

            if (linea.tipo_dcto == 0) {
                linea.dcto = (linea.precio * linea.cantidad * linea.dcto) / 100;
                linea.tipo_dcto = 1;
            }

            linea.total = linea.subtotal - linea.dcto;
            const iva = this.ivas.find((ele) => ele.id == linea_l.id_iva);
            // console.log('iva', iva);

            linea_l.iva = (linea_l.total / 100) * iva?.descripcion ?? 0;
            // console.log('linea', linea);

            return JSON.parse(JSON.stringify(linea));
        },
        addLinea() {
            // this.linea.tipo_dcto = 1;

            //  console.log("iva", iva.descripcion);
            if (this.$route.meta.especial) {
                this.linea.id_iva = 4;
            }
            this.albaran.lineas.push(this.getLinea(this.linea));

            this.linea = {
                id_pedido: null,
                id_iva: 1,

                id_pedido_linea: null,
                id: null,
                id_producto_compra: null,
                nombre_producto: "",
                descripcion: null,
                cantidad: null,
                precio: null,
                tipo_dcto: 1,
                dcto: 0,
                subtotal: 0,
                total: 0,
                observaciones: "",
            };
        },
        openEditDialog(item) {
            this.editlinea = JSON.parse(JSON.stringify(item));
            this.editlinea.index = this.albaran.lineas.indexOf(item);
            this.dialog = true;
        },
        Edit() {
            let index = this.editlinea.index;
            let linea = this.getLinea(this.editlinea);
            this.albaran.lineas[index] = JSON.parse(JSON.stringify(linea));
            this.albaran.lineas = JSON.parse(
                JSON.stringify(this.albaran.lineas)
            );
            this.dialog = false;
        },
        deleteLinea() {
            let index = this.albaran.lineas.indexOf(this.editlinea);

            this.albaran.lineas.splice(index, 1);
            this.delete_dialog = false;
        },
        openDeleteDialog(item) {
            this.editlinea = item;
            this.delete_dialog = true;
        },

        // Metodos generales
        getIvas() {
            axios.get(`api/get-iva`).then((res) => {
                this.ivas = res.data.success;
            });
        },

        // Acciones de factura
        openFacturaDialog() {
            this.confirm_factura = true;
        },
        crearFactura() {
            axios
                .post("api/create-factura-entrante", this.albaran)
                .then((res) => {
                    //this.$router.push("lista-albaranes");
                    this.confirm_factura = false;
                    this.factura_id = res.data.data.id;
                    this.redirect_factura = true;
                })
                .catch((error) => {
                    if (error.response.code == 400) {
                        this.$custom_error(error.response.data.error);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        generarNota() {
            this.albaran.especial = this.$route.meta.especial;
            let nota = {
                id: null,
                albaranes: [this.albaran],
            };
            axios
                .post("api/generar-nota", nota)
                .then((res) => {
                    this.$router.push(this.$route.meta.lista);
                })
                .catch((error) => {
                    if (error.response.code == 400) {
                        this.$custom_error(error.response.data.error);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },

        // Metodos auxiliares
        getPedidos(id_proveedor) {
            axios
                .get(
                    `api/get-pedidos-proveedor?page=1&amount=-1&id_proveedor=${id_proveedor}`
                )
                .then(
                    (res) => {
                        this.Pedidos = res.data.data;
                    },
                    (err) => {
                        this.$custom_error("Error consultando el pedido");
                    }
                );
        },
        proveedorSelected(id) {
            let proveedor_selected;
            if (id == this.albaran.proveedor?.id) {
                proveedor_selected = this.albaran.proveedor;
            } else {
                proveedor_selected = this.proveedores.find(
                    (element) => element.id === id
                );
            }
            if (this.linea != null) {
                this.linea.tipo_dcto = proveedor_selected.tipo_dcto ?? 1;
                this.linea.dcto = proveedor_selected.dcto ?? 0;
            }
            this.getPedidos(id);
        },

        // Acciones de archivo
        deleteArchivo(archivo) {
            axios.get(`api/delete-archivo-albaran/${archivo.id}`).then(
                (res) => {
                    this.albaran.archivo = res.data;
                },
                (res) => {
                    this.$toast.error("Error al eliminar el archivo");
                }
            );
        },
        subirArchivo(data) {
            axios
                .post(`api/save-archivo-albaran`, {
                    id: this.albaran.id,
                    archivo: data.data,
                    nombre: data.nombre,
                    extension: data.extension,
                })
                .then((res) => {
                    this.albaran.archivo = res.data;
                });
        },

        // En desuso
        openDescripcion() {
            if (!this.$refs.linea_form.validate()) return;

            this.product_dialog = true;
        },
        getProductoCompra() {
            axios
                .post(`api/get-producto-by-name`, {
                    nombre_producto: this.linea.nombre_producto,
                })
                .then(
                    (res) => {
                        this.producto = res.data.success;

                        if (this.producto != null) {
                            this.linea.id_producto_compra = this.producto.id;
                            this.linea.cantidad = this.producto.cantidad;
                            this.linea.precio = this.producto.precio;
                            this.linea.id_producto_compra = this.producto.id;
                        }
                    },
                    (res) => {}
                );
        },
        formatPrice,
        /*formatNumber(number) {
            if (number == null) return "null";
            return Number.parseFloat(number.toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },*/
    },
    computed: {
        proveedores() {
            ///console.log("siva");
            let proveedores_temp = this.$store.getters.getproveedores;

            // console.log(proveedores_temp);
            return proveedores_temp;
        },
        total() {
            /*let total = 0;
                this.albaran.lineas.forEach((elemento) => {
                    total += elemento.total;
                });
                this.albaran.importe = total;
                return total;*/
            let totales = {};
            console.log("albaran.lineas", this.albaran.lineas);

            this.albaran.lineas.forEach((elemento) => {
                let total = 0;

                let iva = this.ivas.find(
                    (element) => element.id == elemento.id_iva
                )?.descripcion;
                // total_sin_iva = elemento.total/(1 + parseInt(iva)/100);
                // elemento.iva = iva;

                total += elemento.total;
                if (iva in totales) {
                    totales[iva] += total;
                } else {
                    totales[iva] = total;
                }
            });

            // Sumar los valores de los totales de IVA en el objeto presupuesto.ivas
            let total = Object.values(totales).reduce(
                (total, valor) => total + valor,
                0
            );
            this.albaran.importe = total;
            return total;
        },
        iva() {
            let ivas = {};
            this.albaran.lineas.forEach((elemento) => {
                let iva_linea = 0;
                // let total_sin_iva = 0;
                let total = 0;
                let iva = this.ivas.find(
                    (element) => element.id == elemento.id_iva
                )?.descripcion;

                // total_sin_iva = elemento.total/(1 + parseInt(iva)/100);
                total += elemento.total;
                iva_linea = (total * parseInt(iva)) / 100;
                // elemento.iva = iva;

                // Agregar el IVA al tipo de IVA correspondiente en el objeto ivas
                if (iva in ivas) {
                    ivas[iva] += iva_linea;
                } else {
                    ivas[iva] = iva_linea;
                }
            });

            // Sumar los valores de los totales de IVA en el objeto presupuesto.ivas
            let totalIva = Object.values(ivas).reduce(
                (total, iva) => total + iva,
                0
            );
            this.albaran.iva = totalIva;
            return ivas;
        },
        isloading() {
            return this.$store.getters.getloading;
        },
        lineas_formated() {
            return this.albaran.lineas.reduce((acc, item) => {
                if (acc[item.id_pedido] == null)
                    acc[item.id_pedido] = {
                        pedido: "Pedido " + item.id_pedido,
                        lineas: [],
                    };
                acc[item.id_pedido].lineas.push(item);
                return acc;
            }, {});
        },
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}

.spacing {
    padding-top: 0 !important;
}
</style>
